import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.WalletsPage.KycPage.ApprovedPage', {
    pageTitle: 'Wallets - Onboarding | {companyName} | Approved',
    title: 'Your application to open a wallet has been approved!',
    weArePleased:
        'We are pleased to inform you that your application to open a wallet has been approved.{br}The final step is to accept the {terms} for opening a wallet.',
    beAdvised: 'Please be advised that this step may take up to 48 hours.',
    terms: 'terms and conditions',
    accept: 'Accept',
});
